import state from '@/store/modules/menu_info/state'
import actions from '@/store/modules/menu_info/actions'

import getters from '@/store/modules/menu_info/getters'

export default {
  state,
  actions,  
  getters
}
